import React from 'react';
import useCurrentAuthority from 'src/hooks/useCurrentAuthority';
import UI_UTILS from 'src/utils/uiUtils';
import { Help } from '@drift-labs/icons';
import Text from 'src/components/Text/Text';

const MobileHelpButton = () => {
	const currentWalletAuthority = useCurrentAuthority();

	const openSupportWidget = () => {
		UI_UTILS.openSupportWidget(currentWalletAuthority?.toString());
	};

	return (
		<div
			onClick={openSupportWidget}
			className="flex items-center w-full space-x-2 outline-none text-text-default"
		>
			<Help size={18} color="var(--text-label)" />
			<div>
				<Text.BODY3 className="text-left">Help &</Text.BODY3>
				<Text.BODY3 className="block text-left">Feedback</Text.BODY3>
			</div>
		</div>
	);
};

export default MobileHelpButton;
